<style lang="less" scoped>
  .number_table {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .number-col {
    width: 16.66%;
    border: 1px solid white;
    height: 44px;
    display: flex;
    position: relative;
  }
  .active {
    background: rgba(255, 255, 255, .3);
  }
  .delete-button-component {
    position: absolute;
    right: 0;
    top: 0;
    margin-top: -13px;
    margin-right: -13px;
    z-index: 100;
  }
  .number-slot {
    border-right: 1px solid rgba(255, 255, 255, .4);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // &:last-child {
    //   border-right: none;
    // }
  }
</style>

<template lang="pug">
  .number_table
    .number-col(
      v-for='(data, i) in answerDisplay',
      @click='handleClicked(i)'
      :class='{ active: focus == i  }')
      delete-button-component.delete-button-component(
        v-if='focus === i && controls && getInputGroup(startIndex + i).length'
        @click.native='clearColumn()')
      .number-slot(
        :style='{ width: `${slotWidth}%` }'
        v-for='(column, k) in data')
        number-component(
          v-if='getNumber(startIndex + i, k) !== false'
          :style='{ width: width + "px" }'
          :number='getNumber(startIndex + i, k)')
</template>

<script>
import NumberComponent from '@/components/number_panel';
import DeleteButtonComponent from '@/components/delete_button';

export default {
  data() {
    return {
      answerDisplay: [],
    };
  },
  props: {
    page: {
      type: Number,
      default: 0,
    },
    units: {
      type: Number,
      default: 1,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    input: {
      type: Array,
      default: () => [],
    },
    focus: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 16,
    },
  },
  watch: {
    page() {
      this.answerDisplay = this.getAnswerDisplay();
    },
  },
  methods: {
    getAnswerDisplay() {
      const answer = this.answer;
      const arr = [];
      for (let i = this.startIndex; i < this.startIndex + 24; i += 1) {
        if (i >= answer.length) break;
        arr.push(answer[i]);
      }
      return arr;
    },
    clearColumn() {
      this.$emit('click-clear');
    },
    handleClicked(index) {
      this.$emit('click-column', index);
    },
    getInputGroup(index1) {
      if (index1 in this.input) {
        return this.input[index1];
      }
      return false;
    },
    getNumber(index1, index2) {
      const input = this.getInputGroup(index1);
      if (input) {
        if (index2 in input) {
          return input[index2];
        }
      }
      return false;
    },
  },
  computed: {
    startIndex() {
      return this.page * 24;
    },
    answer() {
      return this.$store.state.app.answer;
    },
    slotWidth() {
      return 100 / this.units;
    },
  },
  mounted() {
    this.answerDisplay = this.getAnswerDisplay();
  },
  components: {
    NumberComponent,
    DeleteButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/number_table.vue